import styled from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const UserMenuCloseIconDefaultBox = styled.div`
    width: 1.4rem;
    height: 1.4rem;
    padding: 0.4rem;
    box-sizing: content-box;
    border: 2px solid ${({theme}) => theme.colors.boxBorderContrast};
    border-radius: 50%;
    color: ${({theme}) => theme.colors.textMiddleDark};
    margin-right: 0.5rem;
    ${CssRule.For.mobile.build()} &{
        width: 2rem;
        height: 2rem;
        padding: 0.55rem;
        margin-right: 0;
    }
    &:hover {
        cursor: pointer;
    }
`;

const UserMenuCloseIconCasino777Box = styled(UserMenuCloseIconDefaultBox)`
    border: 1px solid ${({theme}) => theme.colors.boxBorderContrast};
    border-radius: 5px;
`;

const UserMenuCloseIconSiBox = styled(UserMenuCloseIconDefaultBox)`
    border: 2px solid ${({theme}) => theme.colors.textMiddleDark};
    ${CssRule.For.mobile.build()} &{
        color: ${({theme}) => theme.colors.textContrast};
        border-color: ${({theme}) => theme.colors.boxBorderContrast};
    }
`;

export const UserMenuCloseIconBox = styledByTheme(UserMenuCloseIconDefaultBox)
    .forCasino777(UserMenuCloseIconCasino777Box)
    .forSI(UserMenuCloseIconSiBox).apply();
